import AffiliateMarketingZipCodeForm from '@root/joinroot.com/src/components/forms/affiliate-marketing-zip-code-form';
import GetTheAppForm from '@root/joinroot.com/src/components/forms/get-the-app-form';
import HomeownersZipCodeForm from '@root/joinroot.com/src/components/forms/homeowners-zip-code-form';
import PropTypes from '@root/vendor/prop-types';
import RentersZipCodeForm from '@root/joinroot.com/src/components/forms/renters-zip-code-form';
import snakeCase from '@root/vendor/lodash/snakeCase';

const FormComponents = {
  'AFFILIATE_MARKETING_ZIP_CODE_FORM': AffiliateMarketingZipCodeForm,
  'HOMEOWNERS_ZIP_CODE_FORM': HomeownersZipCodeForm,
  'RENTERS_ZIP_CODE_FORM': RentersZipCodeForm,
  'GET_THE_ROOT_APP': GetTheAppForm,
};

export default function CustomFormBlock({ content, analytics }) {
  const formId = snakeCase(content.formId)?.toUpperCase();
  const ComponentToRender = FormComponents[formId];

  if (!formId) {
    return null;
  }

  if (!ComponentToRender) {
    throw new Error(`No component found to render ${content.formId}.`);
  }

  return <ComponentToRender analytics={analytics} />;
}

CustomFormBlock.propTypes = {
  analytics: PropTypes.object,
  content: PropTypes.shape({
    formId: PropTypes.string.isRequired,
  }).isRequired,
};
